import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.gap};
  padding: ${({ theme }) => theme.metrics.padding};
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.05, theme.colors.background)};
  border: 1px solid ${({ theme }) => darken(0.1, theme.colors.background)};
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.metrics.desktop_small}) {
    width: 100%;
    max-height: 720px;
  }
`;

export const Header = styled.div`
  width: 100%;
  min-height: 38px;
  display: flex;
  align-items: center;
  gap: 50px;
  padding: ${({ theme }) => theme.metrics.padding};
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
`;

export const Title = styled.h4`
  margin-left: ${({ theme }) => theme.metrics.margin};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textBackground};
`;

export const List = styled.ul`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.metrics.radius};
`;

export const ScrollControl = styled.li`
  width: 100%;
  display: flex;
  justify-content: center;
`;
